const isProductionURL =
  typeof window !== 'undefined' &&
  window.location.hostname === 'assistant.thisandthat.chat';

interface GTMEventData {
  event: string;
  [key: string]: any;
}

export function pushGTMEvent(eventData: GTMEventData): void {
  if (!isProductionURL) {
    return;
  }

  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }

  window.dataLayer.push(eventData);
}
